/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import getColor from "@insite/mobius/utilities/getColor";
import { recentWishListsStyles } from "@monsma/Overrides/Widgets/Common/RecentWishLists";
import { styledBox } from "@monsma/XDL/Components/Common/Box";
import { widgetHeaderContentStyle } from "@monsma/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

recentWishListsStyles.wishListCard = {
    actionAddToCartButton: {
        typographyProps: {
            size: 14,
        },
    },
    sharingStatusGridItem: {
        css: css`
            display: none;
        `,
    },
};

recentWishListsStyles.wishListsWrapper = {
    css: css`
        ${styledBox};
        border-radius: 0;
        padding: 0;
        width: 100%;
    `,
};

recentWishListsStyles.cardListGrid = {
    width: 12,
    css: css`
        display: block;
    `,
};

recentWishListsStyles.cardList = {
    gap: 0,
    css: css`
        margin: 0 0 30px 0;
    `,
};

recentWishListsStyles.wishListCardContainer = {
    gridItem: {
        css: css`
            padding: 20px 0;
        `,
    },
    cardDivider: {
        css: css`
            border-bottom: 1px solid ${getColor("common.ui12")};
            padding: 0 20px;

            &:last-child {
                border-bottom: 0;
            }
        `,
    },
};

recentWishListsStyles.headerStyling = {
    css: css`
        ${widgetHeaderContentStyle}
    `,
};
